import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const documentUpload = ( files) => {
  const loginData = secureLocalStorage.getItem("loginCredentials");
  const formData = new FormData();
  // formData.append("file", files);
  formData.append("user_id", loginData.user.id);
  // formData.append("case_id", threadId);
  // formData.append("message_id", randomId);

  if (files) {
    formData.append("file", files);
  }
  return new Promise((resolve, reject) => { 
    axios
      .post( `${process.env.REACT_APP_PYTHON_URL}/api/v1/documents/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {

        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

export {
  documentUpload
}